import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { getPages } from 'component/pagination/utils'
import { actionSet } from './utils'

import {
  FETCH_ADJUSTMENT_VALUES_REQUEST,
  FETCH_ADJUSTMENT_VALUES_SUCCESS,
  FETCH_ADJUSTMENT_VALUES_ERROR,
} from 'actionTypes'
import { hideSpinner , showSpinner} from './spinner'

export const fetch = (token, filters) => (dispatch) => {
  dispatch(actionSet(FETCH_ADJUSTMENT_VALUES_REQUEST))

  return new Api(token, dispatch)
    .get(API_URL.FETCH_ADJUSTMENT_VALUES, filters)
    .then((response) => {
      dispatch(getPages(response.metadata))
      dispatch(actionSet(FETCH_ADJUSTMENT_VALUES_SUCCESS, response.data))
    })
    .catch((error) => dispatch(actionSet(FETCH_ADJUSTMENT_VALUES_ERROR, error)))
}

export const v2Fetch = (token, filters,signalController) => (dispatch) => {
  dispatch(actionSet(FETCH_ADJUSTMENT_VALUES_REQUEST))

  const onClose = () => {
    dispatch(hideSpinner())
    dispatch(hideSpinner())

  }

  const onError = (error) => {
    dispatch(actionSet(FETCH_ADJUSTMENT_VALUES_ERROR, error))
    onClose()
  }

  const onMessage = (response) => {
    dispatch(getPages(response.metadata))
      dispatch(actionSet(FETCH_ADJUSTMENT_VALUES_SUCCESS, response.data))
  }

  const abort = () => {
    signalController.abort()
    dispatch(hideSpinner())
    dispatch(hideSpinner())
  }

  dispatch(showSpinner("", true, abort))
  return new Api(token, dispatch)
    .eventSourceStream(API_URL.V2_FETCH_ADJUSTMENT_VALUES, filters, null, signalController, onMessage, onClose, onError)
    .catch((error) => onError(error))
}